<template>
   <v-layout column justify-center align-center class="mt-4 pt-2">
    <!-- <VueCompareImage
      class="hidden-md-and-down"
      hover
      :style="{ maxWidth: '1000px' }"
      :sliderLineWidth="sliderLine"
      :handleSize="hSize"
      :leftImage="leftImage"
      :rightImage="rightImage"
      :sliderPositionPercentage="sliderPosition"
    />
    <VueCompareImage
      class="hidden-lg-and-up"
      hover
      :style="{ maxWidth: '400px' }"
      :sliderLineWidth="sliderLine"
      :handleSize="hSize"
      :leftImage="leftImage2"
      :rightImage="rightImage2"
      :sliderPositionPercentage="sliderPosition"
    /> -->

    <br>

    <vue-typer class="headline" :repeat="0" text="Mathieu Baesen"></vue-typer>
    <vue-typer
      :text="text1"
      :repeat="Infinity"
      :shuffle="false"
      initial-action="erasing"
      :pre-type-delay="70"
      :type-delay="70"
      :pre-erase-delay="1980"
      :erase-delay="150"
      erase-style="select-back"
      :erase-on-complete="false"
      caret-animation="smooth"
    ></vue-typer>



    <v-flex xs12 sm6 md4 lg4 xl4>

      <v-card hover flat color="transparent">
        <v-img
          :src="profile"
          aspect-ratio="1.7778"
          alt="NULL"
          lazy-src="https://cdn.dribbble.com/users/503653/screenshots/3143656/fluid-loader.gif"
        ></v-img>
      </v-card>

      <v-card flat color="transparent" max-width="500">
        <v-card-title primary-title>
          <div>
            <h3 class="headline mb-0">
              <span>About</span>
              <span class="green--text">Me</span>
            </h3>
            <div>
              <p>
                Hello! I’m Mathieu Baesen. I'm a Engineering student who
                is passionate about
                <span
                  class="green--text font-weight-bold"
                >Video Games</span> as a narrative media and by
                <span
                  class="green--text font-weight-bold"
                >japanese</span> modern culture.
              </p>

              <p>
                I love narrative arts, whatever their form, and I hope to be able to create some one day.
              </p>

              <p>
                Get to know me!
                <br><br>
                My favorites Animes are : <a href="https://myanimelist.net/anime/11981/Mahou_Shoujo_Madoka%E2%98%85Magica_Movie_3__Hangyaku_no_Monogatari">Puella Magi Madoka Magica</a>, <a href="https://myanimelist.net/anime/18617/Girls___Panzer_Movie">Girls und Panzer</a>, <a href="https://myanimelist.net/anime/41169/Love_Live_Superstar">Love Live! Superstar</a>
                <br>
                My favorites games are : <a href="https://www.backloggd.com/games/honkai-impact-3rd/">Honkai Impact 3rd</a>, <a href="https://www.backloggd.com/games/nier-automata/">Nier;Automata</a>, <a href="https://www.backloggd.com/games/the-legend-of-zelda-breath-of-the-wild/">The Legend of Zelda Breath of the Wild</a>
                <br>
                My favorites movies are : <a href="https://letterboxd.com/film/skyfall/">Skyfall</a>, <a href="https://letterboxd.com/film/pacific-rim/">Pacific Rim</a>, <a href="https://letterboxd.com/film/die-hard-with-a-vengeance/">Die Hard 3</a>
                <br>
                My favorites novels are : <a href="https://www.goodreads.com/book/show/57891.Battle_Royale">Battle Royale</a>, <a href="https://www.goodreads.com/series/281276-otherside-picnic-light-novel">Otherside Picnic</a>, <a href="https://www.goodreads.com/series/165649-fate-strange-fake">Fate/Strange Fake</a>
              </p>

              <!--
              <p>
                You can find me on Social Medias with <a href="https://mathxxl.carrd.co/">Carrd.co</a>.
              </p>
              -->
            </div>
          </div>
        </v-card-title>

        <v-card-actions class="hidden-sm-and-down">
          <v-btn
            v-for="icon in icons"
            :key="icon.icon"
            fab
            dark
            outline
            color="green"
            :href="icon.href"
            target="_blank"
          >
            <v-icon dark>{{icon.icon}}</v-icon>
          </v-btn>
        </v-card-actions>

        <v-card-actions class="hidden-md-and-up justify-center">
          <v-btn
            v-for="icon in icons"
            :key="icon.icon"
            small
            fab
            dark
            outline
            color="green"
            :href="icon.href"
            target="_blank"
          >
            <v-icon dark>{{icon.icon}}</v-icon>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
import { VueTyper } from 'vue-typer'
import VueCompareImage from 'vue-compare-image'

export default {
  metaInfo: {
    title: 'About Me',
    titleTemplate: "%s ← Mathieu's Space",
    meta: [
      { name: 'viewport', content: 'width=device-width, initial-scale=1' },
      { name: 'description', content: "Mathieu Baesen's Portfolio" },
      { charset: 'utf-8' },
      { property: 'og:title', content: "Mathieu' Space" },
      { property: 'og:site_name', content: "Mathieu' Space" },
      { property: 'og:type', content: 'website' },
      { property: 'og:url', content: 'https://Mathieu.space' },
      { property: 'og:description', content: "Mathieu Baesen's Portfolio" }
    ]
  },
  components: {
    'vue-typer': VueTyper,
    VueCompareImage
  },
  data () {
    return {
      icons: [
        //{ href: 'https://github.com/Mathxxl', icon: 'fab fa-github' },
        {
          href: 'https://www.linkedin.com/in/mathieu-baesen-2a3894204/',
          icon: 'fab fa-linkedin-in'
        },
        {href:'https://mathxxl.itch.io/', icon:'fab fa-itch-io'}
      ],
      text1: ['Music Composition', 'Game Development', 'Programmer'],
      leftImage: 'https://wallpaperaccess.com/full/279979.jpg',
      rightImage: 'https://www.wallpapertip.com/wmimgs/35-356026_artificial-intelligence-logo-design.jpg',
      leftImage2: 'https://wallpaperaccess.com/full/279979.jpg',
      rightImage2: 'https://www.wallpapertip.com/wmimgs/35-356026_artificial-intelligence-logo-design.jpg',
      sliderLine: 0,
      hSize: 0,
      sliderPosition: 0.5,
      profile:'data/mathieu_baesen.jpg'
    }
  }
}
</script>
<style>
@keyframes rocking {
  0%,
  100% {
    transform: rotateZ(-10deg);
  }

  50% {
    transform: rotateZ(10deg);
  }
}

.vue-typer {
  font-family: Arial, "Helvetica Neue", Helvetica, sans-serif;
}
.vue-typer .custom.char.typed {
  color: green;
}
.vue-typer .custom.char.selected {
  color: #e91e63;
}

.vue-typer .custom.caret {
  animation: rocking 1s ease-in-out 0s infinite;
}
.vue-typer .custom.caret.typing {
  background-color: green;
}
.vue-typer .custom.caret.selecting {
  display: inline-block;
  background-color: #e91e63;
}

a:link {
  color: green;
  background-color: transparent;
  text-decoration: none;
}
a:active {
  color: darkgreen;
  background-color: transparent;
  text-decoration: none;
}
p{
  text-align: justify;
}
</style>
